import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";
import LeadsComp from "../components/leads-comp/LeadsComp";

const LeadsPage = () => {
  return (
    <Layout>
      <SEO
        title={"Unflux Leads"}
        description={
          "A six-week clinic helping senior product designers make the jump to lead — Product, Process, People."
        }
        keywords={[
          "design leadership",
          "senior to lead",
          "design lead",
          "product design",
          "design management",
        ]}
      />
      <LeadsComp />
    </Layout>
  );
};

export default LeadsPage;
